import React from "react";

import { Icon } from "components";

import { PracticeTableTooltip } from "pages/app/historical-practice-data-table-view/components/PracticeTableTooltip";

type PracticeChipProps = {
  practiceName: React.ReactNode;
  hasMissingData: boolean;
  isEditable: boolean;
  onClick: () => void;
};

// shared by historical-practice-data-table-view/MissingDataTable.tsx and all-fields-data-table-view/AllFieldsDataTable.tsx
export const PracticeChip = ({ practiceName, hasMissingData, isEditable, onClick }: PracticeChipProps) => (
  <PracticeTableTooltip title={practiceName}>
    {({ ref }) => (
      <div
        className={`historical-practice-data-table-view-practice-chip ${!isEditable ? "confirmed" : ""} ${hasMissingData ? "incomplete-practice" : ""}`}
        onClick={(e) => {
          e.stopPropagation();

          if (isEditable || hasMissingData) {
            onClick();
          }
        }}
      >
        {hasMissingData ? (
          <Icon size="xs" iconName="tabler/alert-circle" className="historical-practice-data-table-view-practice-alert-icon" />
        ) : !isEditable ? (
          <Icon size="xs" iconName="tabler/lock" className="historical-practice-data-table-view-practice-lock-icon" />
        ) : null}
        <span ref={ref}>{practiceName}</span>
      </div>
    )}
  </PracticeTableTooltip>
);
